// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2OZ-2","choiceBoxes":"toolbarselects_choiceBoxes__LWo3s","simpleField":"toolbarselects_simpleField__1AxsE"};